import AssignmentEditorContainer from './AssignmentEditorContainer';

export default AssignmentEditorContainer;
